import { usePublishEvent } from '@/analytics/usePublishEvent';
import { RequiredActions, SignInApiClient } from '@/api/sign-in';
import type { IdentifierType } from '@/api/types';
import { SignInRoutes } from '@/Routes';
import { useSignInStore } from '@/store/signInStore';
import { useRouter } from 'next/navigation';

export const useResolveIdentifier = () => {
  const updateSession = useSignInStore((state) => state.updateSession);
  const router = useRouter();
  const publishEvent = usePublishEvent();

  return async (identifier: string, identifierType: IdentifierType) => {
    const response = await SignInApiClient.resolveIdentifier(identifier);

    publishEvent('ResolveIdentifier', 'resolve-identifier-form');

    updateSession((s) => ({
      ...s,
      identifier: response.identifier,
      identifierType,
      requiredActions: response.requiredActions,
      validatedAgreements: [],
      additionalValidations: undefined,
      exhaustedMethods: [],
    }));

    const hasCredentialsReset = response.requiredActions?.includes(
      RequiredActions.CREDENTIAL_RESET,
    );

    if (hasCredentialsReset) {
      router.push(SignInRoutes.RESECURE);
      publishEvent('ResecureFlow', 'resolve-email-form');
    }

    return !hasCredentialsReset;
  };
};
